import { PagePredictionProperties, PageTypes } from '@shared/types';
export function isPageProcessingSheet(page) {
    return page.predictions[PagePredictionProperties.type] === PageTypes.processing_sheet;
}
